import React from "react";
import { useSelector } from "react-redux";

import { mode } from "@/models/config";
import { modeEnum } from "@/utils/enum";

const SplitPageSection = (props) => {
  // アクセスモード
  const scMode = useSelector(mode);

  if (scMode === modeEnum.pageEditing) {
    return <div className="split-page-container">改ページ</div>;
  }
  return <React.Fragment />;
};

export default SplitPageSection;
